import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

import { Icon } from "@iconify/react";

const NavRap = styled.div`
  background: #ffffff;
  background-position: top;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 9999;
  border-bottom: 1px solid #34302f1f;
  .all-sticky {
    position: sticky;
    top: 0px;
  }
.logo {
    width: 104px;
    height: 31px;
}
  .dark-nav {
    background: #060B13;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
  }
  .dark-nav-text {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .dark-nav-text p, .dark-read-link {
    color: #FFFFFF;
    font-size: 14px;
    font-weight: 400;

  }


  .nav-link {
    text-decoration: none;
    color: #363D4F;


    font-size: 16px;
    font-weight: 400;
  }
  nav img {
    width: 84px;
    height: 49px;
  }
  .nav-link.active {
    color: #060B13;
    font-weight: 600;
  }
  .navbar {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .nav-mobile {
    display: none;
  }
  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 60px;
  }
  .contact-us {
    border-left: 2px;
    border-top: 2px;
    border-right: 5px;
    border-bottom: 5px;
    border-style: solid;
    border-radius: 100px;
    width: 130px;
    height: 55px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-color: #060B13;
    color: #060B13;
    font-size: 16px;
    font-weight: 600;
    text-decoration: none;
  }
  .contact-search {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  .service-dropdown {
    background: #ffffff;
    border: 1px solid #34302f1a;
    width: 294px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;

    position: absolute;
    top: 30px;
  }
  .service-links {
    padding: 10px 15px;
    color: #34302f;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
  }
  .service-links:hover {
    background: #f7f7f7;
  }
  @media (max-width: 678px) {
    .navbar {
      display: flex;
      flex-direction: column;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      position: fixed;
      top: 70px;
      left: -360px;
      width: 300px;
      height: 100vh;
      background: #ffffff;
      color: #34302f;
      box-shadow: 0 40px 60px rgba(0, 0, 0, 0.1);
      padding: 40px 0 0 30px;
      transition: 0.3s ease-in-out;
      z-index: 9999;
    }

    .navbar.active {
      left: 0px;
    }
    .nav-mobile {
      display: block;
    }
    .nav-upper {
      padding: 8px 30px;
    }
    .nav-lower {
      padding: 0px 30px;
    }
    nav {
      padding: 10px 20px !important;
    }
  }
  @media (max-width: 550px) {
  }
`;

const Navbar = () => {
  const [clicked, setClicked] = useState(false);
  const [activeLink, setActiveLink] = useState("home");
  const [serviseShow, setServiceShow] = useState(false);
  const handleClick = () => {
    setClicked(!clicked);
  };

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };
  const { pathname } = useLocation();
  useEffect(() => {
    setClicked(false);
  }, [pathname]);

  const showServiceLinks = () => {
    setServiceShow(!serviseShow);
    setActiveLink("services");
  };
  return (
    <NavRap>
        <div className="all-sticky">
            <div className="dark-nav">
                <div></div>
                <div className="dark-nav-text">
                    <p>This just in: Learn what we launched in our streaming keynote recap...</p>
                    <Link className="dark-read-link">Read more</Link>
                </div>
                <div>
                <Icon
              width="14px"
              height="14px"
              icon="humbleicons:times"
              style={{ color: "#FFFFFF" }}
            />
                </div>
            </div>
      <nav>
        <div className="nav-mobile" onClick={handleClick}>
          {clicked ? (
            <Icon
              width="30px"
              height="30px"
              icon="prime:times"
              style={{ color: "#34302F" }}
            />
          ) : (
            <Icon
              width="30px"
              height="30px"
              icon="mdi-light:menu"
              style={{ color: "#34302F" }}
            />
          )}
        </div>
        <img className="logo" src="/images/logo.png" alt="" />

        <div className={clicked ? "navbar active" : "navbar"} id="#navbar">
          <Link
            className={`nav-link ${activeLink === "home" ? "active" : ""}`}
            to="/"
            onClick={() => handleLinkClick("home")}
          >
            Features
          </Link>
          <Link
            className={`nav-link ${activeLink === "explore" ? "active" : ""}`}
            to="/explore"
            onClick={() => handleLinkClick("explore")}
          >
            Explore
          </Link>
          
          <Link
            className={`nav-link company ${
              activeLink === "pricing" ? "active" : ""
            }`}
            to="/pricing"
            onClick={() => handleLinkClick("pricing")}
          >
            Pricing
          </Link>
          <Link
            className={`nav-link ${activeLink === "about" ? "active" : ""}`}
            to="/company"
            onClick={() => handleLinkClick("about")}
          >
            Company
          </Link>
        </div>

          <Link to="/login" className="contact-us">
            Login
          </Link>
        
      </nav>
      </div>
    </NavRap>
  );
};

export default Navbar;
